import PropTypes from 'prop-types';
import classNames from 'clsx';

import css from './pill-button.module.scss';
import PillButtonLink from './PillButtonLink';

const OutlinedPillButtonLink = ({ className, ...otherProps }) => (
  <PillButtonLink
    className={classNames(css.outlinedButton, className)}
    {...otherProps}
  />
);

OutlinedPillButtonLink.propTypes = {
  className: PropTypes.string,
};

export default OutlinedPillButtonLink;
